
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"8","height":"8","viewBox":"0 0 8 8","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M4.66303 4.00575L7.48141 1.18729C7.66482 1.00396 7.66482 0.707544 7.48141 0.524215C7.29808 0.340887 7.00166 0.340887 6.81833 0.524215L3.99987 3.34267L1.1815 0.524215C0.998082 0.340887 0.70175 0.340887 0.518421 0.524215C0.335006 0.707544 0.335006 1.00396 0.518421 1.18729L3.3368 4.00575L0.518421 6.8242C0.335006 7.00753 0.335006 7.30395 0.518421 7.48728C0.609785 7.57873 0.729915 7.62467 0.849959 7.62467C0.970003 7.62467 1.09005 7.57873 1.1815 7.48728L3.99987 4.66882L6.81833 7.48728C6.90978 7.57873 7.02983 7.62467 7.14987 7.62467C7.26992 7.62467 7.38996 7.57873 7.48141 7.48728C7.66482 7.30395 7.66482 7.00753 7.48141 6.8242L4.66303 4.00575Z","fill":"#9C9FAA","stroke":"#9C9FAA","stroke-width":"0.5"}})])
          )
        }
      }
    